module.exports = __webpack_public_path__ + "img/IMG_1444_FoamcoreMatted.755800d8.jpg";